import { render, staticRenderFns } from "./Role-Access.vue?vue&type=template&id=e847c7e4&scoped=true"
import script from "./Role-Access.vue?vue&type=script&lang=js"
export * from "./Role-Access.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e847c7e4",
  null
  
)

export default component.exports